<div class="{{poClass}}">
    <p>Data Inicial</p>
    <po-datepicker formControlName="{{startDateControlName}}" (p-change)="onStartChange($event)" name="data-inicial"></po-datepicker>
</div>

<div class="{{poClass}}">
    <p>Data Final</p>
    <po-datepicker formControlName="{{endDateControlName}}" name="data-final"></po-datepicker>
</div>